import React, { Component } from 'react';
import { Container, Card, Table, Row, Col, Spinner, Image, Badge, Button, Form, Offcanvas } from 'react-bootstrap';
import { t } from '../../helpers/translation_helper';
import NavBar from '../_partials/NavBar/_NavBar';
import Header from '../_partials/Header/_Header';
import { connect } from 'react-redux';
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight, faCalendarAlt, faCheck, faClock, faExternalLink, faFileAlt, faGear, faPaperclip, faTimes, faTrashCan, } from '@fortawesome/free-solid-svg-icons';
import './chat-blog.css';
import { Scrollbar } from 'react-scrollbars-custom';
import imgDescription from '../../assets/images/description.png';
import SweetAlert from 'react-bootstrap-sweetalert';
import { AliceBlue, Argent, Black, BlizzardBlue, Blueberry, ChineseSilver, CyanProcess, DarkElectricBlue, Gray, LightSilver, NewGray, OrangeRYB, PictonBlue, RedLustre, SoftBlue, SonicSilver, SunsetOrange, VividMalachite, White } from '../../helpers/brand_colors_helper';
import { GET, POST } from '../../api';
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper';
import GetIcon from '../../helpers/icon_helper';

// API URL
const apiURL = process.env.REACT_APP_API_URL;

// Portal URL
const portalURL = process.env.REACT_APP_PORTAL_URL;

/**
 * Class Blog Component
 */
class ClassBlog extends Component {
  favoritesOptions = [
    { color: CyanProcess, name: '', value: 1 },
    { color: VividMalachite, name: '', value: 2 },
    { color: OrangeRYB, name: '', value: 3 },
    { color: RedLustre, name: '', value: 4 },
  ]
  /**
   * Constructor
   */
  constructor(props) {
    super(props);
    this.state = {
      chatBlogListParams: {
        limit: 10,
        offset: 0,
        favorite: null,
        filterFavorite: (favorite = null) => this.setState({ chatBlogListParams: { ...this.state.chatBlogListParams, favorite: (this.state.chatBlogListParams.favorite == favorite) ? null : favorite } }),
        refreshing: false,
      },
      chatBlogList: [],
      chatBlogDetails: {
        data: [],
        offset: 0,
        limit: 10,
        refreshing: false,
        finished: false,
      },
      selectedBlog: null,
      msgSending: false,
      message: '',
      attachment: null,
      search: '',
      dragAreaColor: {
        cb_image: ChineseSilver,
        toggleColor: (field, value) => this.setState({ dragAreaColor: { ...this.state.dragAreaColor, [field]: value } })
      },
      deleteModal: { show: false, id: 0, action: () => { }, title: null, desc: null },
      saving: false,
      cb_image: null,
    }
    this.chatEnd = React.createRef();
    this.cb_image_ref = React.createRef();
  }

  /**
   * Component Did Mount
   */
  componentDidMount() {
    this.getListChatBlogs();
  }


  favoriteChatBlog = async () => {
    this.setState({ saving: true })
    const { auth_key, user_id } = this.props.authData.loginData;
    const { center_id } = this.props.authData.centerData;
    const { selectedBlog } = this.state

    const fData = new FormData();

    fData.append('cb_id', selectedBlog.cb_id)
    fData.append('favorite_level', selectedBlog.favorite)
    fData.append('center_id', center_id)
    fData.append('user_id', user_id)

    if (this.favoriteChatBlogReq) {
      this.favoriteChatBlogReq.abort();
    }
    this.favoriteChatBlogReq = new AbortController();

    try {
      const res = await POST('dashboard/favorite-chat-blog',
        fData,
        {
          params: {
            auth_key: auth_key,
          },
          signal: this.favoriteChatBlogReq.signal,
        }
      );
      let resData = res.data
      // console.log('resData', resData);

      if (resData.type) {
        let chatBlogList = this.state.chatBlogList
        chatBlogList = chatBlogList.map((v, i) => {
          if (v.cb_id == selectedBlog.cb_id) {
            return { ...selectedBlog }
          }
          return v
        })
        this.setState({
          chatBlogList: chatBlogList,
          saving: false,
        });
      } else {
        this.setState({
          saving: false,
        });
      }

    } catch (err) {
      toast.error(t('Something went wrong while updating class blog!'));
      // console.log(err);
    }
  }


  /**
   * Get List Chat Blogs
   */
  getListChatBlogs = async () => {
    let chatBlogListParams = this.state.chatBlogListParams
    const { auth_key, center_id, user_id } = this.props.authData.loginData;
    const { class_id, agegroup_id } = this.props.selectedChild;

    this.setState({ chatBlogListParams: { ...chatBlogListParams, refreshing: true } })

    const fData = new FormData();
    fData.append('class_id', class_id);
    fData.append('agegroup_id', agegroup_id);
    fData.append('user_id', user_id);
    fData.append('search', '');
    fData.append('search_favorites', '');
    fData.append('blog_limit', chatBlogListParams.limit);
    fData.append('blog_offset', chatBlogListParams.offset);
    if (chatBlogListParams.favorite) {
      fData.append('favorite', chatBlogListParams.favorite);
    }

    try {
      const res = await POST(
        'dashboard/get-list-chat-blogs',
        fData,
        {

        }
      );
      this.setState({
        chatBlogList: res.data.data,
        chatBlogListParams: { ...chatBlogListParams, refreshing: false }
      });
    } catch (err) {
      toast.error('Something went wrong while fetching class blog!');
      // console.log(err);
    }
  };

  /**
   * Render Chat Blog List
   * @returns {HTMLElement}
   */
  renderChatBlogList = () => {
    const { chatBlogList, chatBlogListParams, selectedBlog } = this.state;
    return chatBlogList.map((item, index) => {
      if (
        this.state.search == '' ||
        ((item.cb_name && ((item.cb_name).toLowerCase()).includes((this.state.search).toLowerCase()))) ||
        ((item.acs_name && ((item.acs_name).toLowerCase()).includes((this.state.search).toLowerCase()))) ||
        ((item.asl_name && ((item.asl_name).toLowerCase()).includes((this.state.search).toLowerCase()))) ||
        ((item.cb_description && ((item.cb_description).toLowerCase()).includes((this.state.search).toLowerCase()))
        )) {

        if (chatBlogListParams.favorite != null && chatBlogListParams.favorite != item.favorite) {
          return null
        }

        let favColor = null
        if (item.favorite) {
          favColor = this.favoritesOptions.find((v) => v.value == item.favorite).color
        }


        let hasImage = null
        if (item.cb_image !== '' && item.cb_image !== null) {
          hasImage = getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/chat_blog/' + item.cb_image
        } else if (item.asl_attach !== '' && item.asl_attach !== null) {
          hasImage = getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_subject_lessons/' + item.asl_attach
        } else if (item.acs_image !== '' && item.acs_image !== null) {
          hasImage = getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_classmain_subject/' + item.acs_image
        } else {
          hasImage = 'https://via.placeholder.com/80?text=No+Thumb'
        }

        return (
          <div key={index} className='chat-blog-item d-flex flex-row' onClick={() => this.handleSelectedBlog(item)} style={{ margin: 10, backgroundColor: (selectedBlog?.cb_id == item.cb_id) ? BlizzardBlue : White, fontSize: 12, border: (selectedBlog?.cb_id == item.cb_id) ? 'solid 1px ' + SoftBlue : 'solid 1px ' + White }}>
            <div style={{ minHeight: '100%', minWidth: 80, width: 80, overflow: 'hidden', borderRadius: 10 }}>
              <Image src={hasImage} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
            <div className='ps-2'>
              <div className='d-flex flex-column'>
                <div className='d-flex flex-row flex-wrap' style={{ fontWeight: 'bold' }} title={item.cb_description}>
                  {favColor &&
                    <div className='me-1' style={{ backgroundColor: favColor, height: 20, width: 20, cursor: 'pointer', borderRadius: 20 }}></div>
                  }
                  {item.cb_name}
                </div>
                <div className='d-flex flex-row align-items-center mt-1'>
                  <div style={{ backgroundColor: CyanProcess, color: White, padding: '1px 3px', borderRadius: 5, fontSize: 11 }} className='d-flex flex-row align-items-center me-2'>
                    {item.acs_name}
                  </div>
                  <div style={{ backgroundColor: (item.status == 0) ? RedLustre : VividMalachite, color: White, padding: '1px 3px', borderRadius: 5, fontSize: 11 }} className='d-flex flex-row align-items-center me-2'>
                    {item.status == 0 ? t('INACTIVE') : t('ACTIVE')}
                  </div>
                </div>
                <div style={{ color: NewGray, fontSize: 11 }} className='d-flex flex-row align-items-center mt-1'>
                  <GetIcon icon={'LuCalendar1'} className={'me-1'} style={{ fontSize: 14 }} />
                  {(item.cb_datetime_updated) ? moment(item.cb_datetime_updated).format('DD-MM-YYYY - h:mm a') : moment(item.cb_datetime).format('DD-MM-YYYY - h:mm a')}
                </div>
              </div>

            </div>
          </div>
        );
      }
      return null
    });
  };

  /**
   * Handle Selected Blog
   * @param {Object} selectedBlog
   */
  handleSelectedBlog = (selectedBlog) => {
    this.setState({ selectedBlog, chatBlogDetails: { ...this.state.chatBlogDetails, data: [], offset: 0, refreshing: false, finished: false } }, () => {
      this.getChatBlogDetails(selectedBlog.cb_id);
    });
  };

  /**
   * Get Chat Blog Details
   * @param {Number} cb_id
   */
  getChatBlogDetails = async (cb_id = this.state.selectedBlog.cb_id) => {
    let chatBlogDetails = this.state.chatBlogDetails
    if (chatBlogDetails.refreshing || chatBlogDetails.finished) {
      return false
    }
    this.setState({ chatBlogDetails: { ...chatBlogDetails, refreshing: true } }, async () => {
      const { auth_key, user_id } = this.props.authData.loginData;
      const { center_id, center_timezone } = this.props.authData.centerData;

      const fData = new FormData();
      fData.append('cb_id', cb_id);
      fData.append('user_id', user_id);
      fData.append('center_id', center_id);
      fData.append('chat_blog_details_limit', chatBlogDetails.limit);
      fData.append('chat_blog_details_offset', chatBlogDetails.offset);

      if (this.getChatBlogDetailsReq) {
        this.getChatBlogDetailsReq.abort();
      }
      this.getChatBlogDetailsReq = new AbortController();

      try {
        const res = await POST(
          'dashboard/get-chat-blog-details',
          fData,
          {
            signal: this.getChatBlogDetailsReq.signal,
          }
        );
        let data = res.data.data

        this.setState({ chatBlogDetails: { ...chatBlogDetails, data: ((data).reverse()).concat(chatBlogDetails.data), offset: chatBlogDetails.offset + chatBlogDetails.limit, refreshing: false, finished: (data.length < chatBlogDetails.limit) ? true : false }, }, () => {
          if (chatBlogDetails.offset == 0) {
            this.chatEnd.current.scrollToBottom();
          }
        });
      } catch (err) {
        toast.error(t('Something went wrong while fetching class blog!'));
        // console.log(err);
      }
    })
  };

  scrollToBottom = () => {
    this.chatEnd.current.scrollIntoView({ behavior: 'smooth' });
  };

  /**
   * Render Chat Message
   * @returns {HTMLElement}
   */
  renderChatMessage = () => {
    const { chatBlogDetails, selectedBlog } = this.state;
    if (selectedBlog == null) {
      return null
    }
    return <div style={{ fontSize: 12 }}>
      <div className='d-flex flex-row justify-content-center align-items-center'>  {chatBlogDetails.refreshing &&
        <Spinner as='span' animation='grow' size='sm' role='status' aria-hidden='true' />
      }
        {chatBlogDetails.finished &&
          <div
            className='chat-message-message'
            style={{
              borderRadius: 15,
              backgroundColor: AliceBlue,
            }}>
            {t('Start of the Blog Conversation')}
          </div>
        }
      </div>
      {chatBlogDetails.data.map((item, index) => {
        return (
          <div
            key={index}
            className='chat-message'
            style={{
              textAlign: item.isOther ? 'left' : 'right',
              padding: '0 10px'
            }}>
            <div className='chat-message-name text-muted'>
              {item.display_name}
            </div>
            <div
              className='chat-message-message'
              style={{
                borderTopLeftRadius: item.isOther ? 0 : 15,
                borderTopRightRadius: item.isOther ? 15 : 0,
                backgroundColor: item.isOther
                  ? ''
                  : 'rgb(226 243 228)',
              }}>
              {item.message}
              {item.attachment && (
                <div>
                  <a
                    href={
                      getRegionalStorageURL() + this.props.authData.centerData.center_uuid +
                      '/chat_blog/' +
                      item.attachment
                    }
                    style={{
                      textDecoration: 'none',
                      color: '#6c757d',
                      fontSize: 13,
                    }}
                    target='_blank'>
                    <FontAwesomeIcon icon={faPaperclip} />{' '}
                    {item.attachment}
                  </a>
                </div>
              )}
            </div>
            <div
              className='chat-message-timestamp'
              style={{
                paddingLeft: item.isOther ? 10 : 0,
                paddingRight: item.isOther ? 0 : 10,
              }}>
              <span title={moment(item.cbd_datetime).format('DD-MM-YYYY - h:mm a')}>{moment(item.cbd_datetime).fromNow(selectedBlog.cb_datetime)}</span>
            </div>
          </div>
        );
      })}
    </div>
  };

  /**
   * Send Message
   */
  sendMessage = async () => {
    this.setState({ msgSending: true });
    const { auth_key, user_id, full_name, role_id } = this.props.authData.loginData;
    const { center_id, center_timezone } = this.props.authData.centerData;
    const { selectedBlog, message, attachment } = this.state;
    if (!message) {
      toast.warning(t('Please write a message'));
      return
    }

    const fData = new FormData();
    fData.append('user_id', user_id);
    fData.append('full_name', full_name);
    fData.append('role_id', role_id);
    fData.append('center_id', center_id);
    fData.append('center_timezone', center_timezone);
    fData.append('cb_id', selectedBlog.cb_id);
    fData.append('chat_blog_message', message);
    fData.append('chat_blog_file', attachment);

    try {
      const res = await POST(
        'dashboard/send-chat-blog-details',
        fData,
        {

        }
      );
      if (res) {
        // console.log('res', res);
        let resData = res.data
        if (!resData.type) {
          toast.error(resData.message);
          this.setState({ msgSending: false });
        } else {
          let chatBlogDetails = this.state.chatBlogDetails
          this.setState({
            message: '',
            attachment: null,
            msgSending: false,
            chatBlogDetails: { ...chatBlogDetails, data: chatBlogDetails.data.concat([resData.data]) }
          }, () => this.chatEnd.current.scrollToBottom());
          // this.setState({
          //   message: '',
          //   attachment: null,
          //   msgSending: false,
          //   chatBlogDetails: {
          //     ...this.state.chatBlogDetails, finished: false, refreshing: false, offset: 0,
          //     limit: 10, data: []
          //   }
          // }, () => {
          //   this.getChatBlogDetails(selectedBlog.cb_id);
          // });
        }
      }
    } catch (err) {
      toast.error(t('Something went wrong while sending message!'));
      // console.log(err);
      this.setState({ msgSending: false });
    }
  };

  setStateChatBlog = (field, value) => {
    if (this.setStateTimer) {
      clearTimeout(this.setStateTimer)
    }
    this.setStateTimer = setTimeout(() => {
      this.setState({ selectedBlog: { ...this.state.selectedBlog, [field]: value } }, () => this.favoriteChatBlog())
    })
  }
  /**
* Preview Upload File
* @returns
*/
  readFile = (selectedFile) => {
    return new Promise(function (resolve, reject) {
      let reader = new FileReader();
      const allowedFiles = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'audio/x-m4a', 'audio/mp3', 'audio/mp4'];
      const allowedFilesDisplay = ['PDF', 'Image'];
      const allowedSize = 5000000;

      if (selectedFile.size) {
        if (selectedFile.size >= allowedSize) {
          toast.error(t('Max file size allowed is ' + allowedSize / 1000000 + ' MB!'));
          resolve({ type: 'error' });
          return;
        } else if (!allowedFiles.includes(selectedFile.type)) {
          toast.error(t('Allowed file type are ' + allowedFilesDisplay.toString()));
          resolve({ type: 'error' });
          return;
        } else {
          if (selectedFile.type.includes('image')) {
            reader.readAsDataURL(selectedFile);
          } else if (selectedFile.type.includes('audio')) {
            reader.readAsArrayBuffer(selectedFile);
          } else {
            reader.readAsText(selectedFile);
          }
        }

        reader.onload = async (readerEvent) => {
          resolve({ type: 'success', data: selectedFile, url: readerEvent.target.result });
        };
        reader.onerror = (error) => {
          resolve({ type: 'error' });
        };
      } else {
        resolve({ type: 'error' });
      }
    });
  };
  addAttachment = (e) => {
    const { defaultTheme } = this.props;
    const selectedFiles = e.target.files;
    let allFiles = [];

    for (let i = 0; i < selectedFiles.length; i++) {
      allFiles.push(this.readFile(selectedFiles[i]));
    }

    Promise.all(allFiles).then((values) => {
      let attachments = e.target.multiple ? this.state[e.target.name] : null;
      let selectedFiles = values;
      selectedFiles.map((v, i) => {
        if (v.data.type) {
          if (e.target.multiple) {
            attachments.push({ url: v.url, data: v.data });
          } else {
            attachments = { url: v.url, data: v.data };
          }
        }
      });
      this.setState({ [e.target.name]: attachments, dragAreaColor: { ...this.state.dragAreaColor, [e.target.name]: Gray } });
    });
  };

  deleteCbImage = (field, actionFun = null) => {
    let selectedBlog = this.state.selectedBlog
    if (selectedBlog.cb_id != null) {
      this.setState({
        deleteModal: {
          ...this.state.deleteModal, show: true, action: () => {
            // DELETE FILE CALL 
            try {
              GET('dashboard/delete-chat-blog-image', {
                params: {
                  key: selectedBlog.cb_id,
                  field: field,
                },
              }).then((res) => {
                if (res) {
                  if (actionFun) {
                    actionFun()
                  }
                  selectedBlog[field] = null

                  this.setState({
                    deleteModal: {
                      ...this.state.deleteModal, show: false
                    },
                    selectedBlog,
                    cb_image: null
                  });
                } else {
                  toast.error(t('Something went wrong while deleting!'));
                }
              })
            } catch (err) {
              toast.error(t('Something went wrong while deleting!'));
              // console.log(err);
            }
          }
        }
      })
    } else {
      selectedBlog[field] = null
      this.setState({ [field]: null, selectedBlog, cb_image: null });
      if (actionFun) {
        actionFun()
      }
    }
  }

  /**
   * Render Component
   * @returns {HTMLElement}
   */
  render() {
    const { defaultTheme } = this.props;
    // State
    const { chatBlogList, selectedBlog, msgSending, message, search, chatBlogListParams } = this.state;
    const dir = this.props.defaultLanguage.lang_orientation

    let selectedBlogHasImage = null
    if (selectedBlog) {
      if (selectedBlog.cb_image !== '' && selectedBlog.cb_image !== null) {
        selectedBlogHasImage = getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/chat_blog/' + selectedBlog.cb_image
      } else if (selectedBlog.asl_attach !== '' && selectedBlog.asl_attach !== null) {
        selectedBlogHasImage = getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_subject_lessons/' + selectedBlog.asl_attach
      } else if (selectedBlog.acs_image !== '' && selectedBlog.acs_image !== null) {
        selectedBlogHasImage = getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_classmain_subject/' + selectedBlog.acs_image
      } else {
        selectedBlogHasImage = 'https://via.placeholder.com/80?text=No+Thumb'
      }
    }

    return (
      <Container fluid>
        <div id='iedu-layout'>
          <NavBar />
          <div id='page-content'>
            <Header lite={true} heading={t('Class Blog')} backBtn={true} func={[this.getListChatBlogs]} showChildSelector={true} />
            <div className='d-flex flex-row' sty>
              <div style={{ width: '30%' }}>
                <div className='grey-section m-0 p-2' style={{ borderRadius: 20 }}>
                  <div className='d-flex flex-row mb-2 p-1'>
                    <div style={{ flex: 1 }}>
                      <Form.Control
                        type='text'
                        placeholder={t('Search...')}
                        onChange={(e) => this.setState({ search: e.target.value })}
                        style={{ borderRadius: 15 }}
                        className='px-2 py-1'
                      />
                    </div>
                    <div className='d-flex flex-row justify-content-center align-items-center ms-1 px-2' style={{ width: 80, overflow: 'hidden', backgroundColor: White, borderRadius: 10, border: 'solid 1px ' + LightSilver }}>
                      <div className='d-flex flex-row justify-content-center align-items-center position-relative' style={{ width: '100%' }}>
                        {this.favoritesOptions.map((favoritesOptions_v, favoritesOptions_i) => {
                          return <div key={favoritesOptions_i} style={{ position: 'absolute', left: 14 * favoritesOptions_i }} onClick={() => chatBlogListParams.filterFavorite(favoritesOptions_v.value)} className='d-flex flex-row align-items-center justify-content-center'>
                            {(chatBlogListParams.favorite == favoritesOptions_v.value)
                              ? <GetIcon icon="MdRadioButtonChecked" style={{ color: favoritesOptions_v.color, fontSize: 22 }} />
                              : <GetIcon icon="FaCircle" style={{ color: favoritesOptions_v.color, fontSize: 18 }} />
                            }
                          </div>
                        })}
                      </div>
                    </div>
                  </div>

                  <Scrollbar style={{ height: '74vh' }} className='border-0 chat-blog-list'>
                    {chatBlogListParams.refreshing ? (
                      <div
                        className='d-flex align-items-center justify-content-center'
                        style={{
                          flexDirection: 'column',
                        }}>
                        <div className='mb-1'>
                          <Spinner
                            animation='grow'
                            variant='dark'
                          />
                        </div>
                        {t(
                          'Fetching class blogs list...'
                        )}
                      </div>
                    ) : (
                      <>
                        {chatBlogList.length > 0 ? (
                          this.renderChatBlogList()
                        ) : (
                          <div
                            className='d-flex align-items-center justify-content-center'
                            style={{
                              flexDirection:
                                'column',
                              height: 400,
                            }}>
                            {t(
                              'No class blogs list found!'
                            )}
                          </div>
                        )}
                      </>
                    )}
                  </Scrollbar>

                </div>
              </div>
              <div style={{ width: '70%' }}>
                {selectedBlog &&
                  <div>
                    <div>
                      <div className='d-flex flex-row align-items-center'>
                        <div className='d-flex flex-row align-items-center justify-content-center' style={{ fontWeight: 'bold', flex: 1 }} title={selectedBlog.cb_description}>{selectedBlog.cb_name}</div>
                        <div className='d-flex flex-row justify-content-center align-items-center ms-1 px-2' style={{ width: 80, height: 30, overflow: 'hidden', backgroundColor: White, borderRadius: 10, border: 'solid 1px ' + LightSilver }}>
                          <div className='d-flex flex-row justify-content-center align-items-center position-relative' style={{ width: '100%' }}>
                            {this.favoritesOptions.map((favoritesOptions_v, favoritesOptions_i) => {
                              return <div key={favoritesOptions_i} style={{ position: 'absolute', left: 14 * favoritesOptions_i }} onClick={() => this.setStateChatBlog('favorite', favoritesOptions_v.value)} className='d-flex flex-row align-items-center justify-content-center'>
                                {(selectedBlog.favorite == favoritesOptions_v.value)
                                  ? <GetIcon icon="MdRadioButtonChecked" style={{ color: favoritesOptions_v.color, fontSize: 22 }} />
                                  : <GetIcon icon="FaCircle" style={{ color: favoritesOptions_v.color, fontSize: 18 }} />
                                }
                              </div>
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{ height: '73vh' }}>
                      <Scrollbar ref={this.chatEnd} className='chat-blog-details' onScroll={(scrollValues, prevScrollValues) => {
                        if (this.chatEnd.current.scrollTop < 20) {
                          this.getChatBlogDetails()
                        }
                      }}>
                        {this.renderChatMessage()}
                      </Scrollbar>
                    </div>
                    <div className='d-flex flex-row align-items-center px-1'>
                      <div style={{ flex: 1 }}>
                        <Form.Control type='text' placeholder={t('Type your message here...')}
                          onChange={(e) => this.setState({ message: e.target.value, })}
                          value={message}
                          className='px-2 py-1'
                          style={{ borderRadius: 40 }}
                        />
                      </div>
                      <div className='ms-2'>
                        <Button variant='primary' size='sm' disabled={msgSending} onClick={() => this.sendMessage()} style={{ borderRadius: 15 }}>
                          <GetIcon icon="LuSendHorizontal" className={'mx-2 my-1'} />
                        </Button>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>



        <SweetAlert
          show={this.state.deleteModal.show}
          warning
          showCancel
          confirmBtnText={t('Yes, delete it!')}
          confirmBtnBsStyle='danger'
          title={(this.state.deleteModal.title) ? this.state.deleteModal.title : t('Are you sure?')}
          onConfirm={this.state.deleteModal.action}
          onCancel={() => this.setState({ deleteModal: { ...this.state.deleteModal, show: false, id: 0, action: () => { } } })}
          focusCancelBtn>
          {(this.state.deleteModal.desc) ? this.state.deleteModal.desc : t('Confirm Delete!')}
        </SweetAlert>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  selectedChild: state.selectedChild.data,
  defaultLanguage: state.language.defaultLanguage,
});

export default connect(mapStateToProps, null)(ClassBlog);
